import { EmailRates as Rates } from './totals';

interface Props {
  rates: Rates;
  openedUnique: number;
  clickedUnique: number;
}

const format = (value: number) => `${value.toFixed(1)}%`;

export default function EmailRates({ rates, openedUnique, clickedUnique }: Props) {
  return (
    <div className="bg-white p-4 rounded shadow mb-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-center">
        <div>
          <span className="block text-sm text-gray-500" title="Entregues dividido por enviados.">
            Taxa de entrega
          </span>
          <span className="block text-xl font-bold">{format(rates.delivery)}</span>
        </div>
        <div>
          <span className="block text-sm text-gray-500" title="Destinatários únicos que abriram, sobre os entregues.">
            Taxa de abertura
          </span>
          <span className="block text-xl font-bold">{format(rates.open)}</span>
          <span className="block text-xs text-gray-400">{openedUnique} únicos</span>
        </div>
        <div>
          <span className="block text-sm text-gray-500" title="Destinatários únicos que clicaram, sobre os entregues.">
            Taxa de clique
          </span>
          <span className="block text-xl font-bold">{format(rates.click)}</span>
          <span className="block text-xs text-gray-400">{clickedUnique} únicos</span>
        </div>
        <div>
          <span
            className="block text-sm text-gray-500"
            title="Hard e soft bounces sobre os enviados. Acima de 2% merece atenção."
          >
            Taxa de bounce
          </span>
          <span className={`block text-xl font-bold ${rates.bounce > 2 ? 'text-red-600' : ''}`}>{format(rates.bounce)}</span>
        </div>
      </div>
    </div>
  );
}
